import React from 'react'
import { useTranslation } from 'react-i18next'
import { Menu } from 'antd'

type ConsentPopoverProps = {
  archive?: (id: string) => void
  consentFormTitle?: string
  edit?: (id: string) => void
  generatePDF?: (id: string, title: string) => void
  id: string
  restore?: (id: string) => void
  view?: (id: string) => void
}

const ConsentPopover = ({
  archive,
  consentFormTitle,
  edit,
  generatePDF,
  id,
  restore,
  view,
}: ConsentPopoverProps) => {
  const { t } = useTranslation()

  return (
    <div>
      <Menu style={styles.menu}>
        {!!view && (
          <Menu.Item data-testid="consent-form-action-view" onClick={() => view(id)}>
            {t(`general.buttons.view`)}
          </Menu.Item>
        )}
        {!!generatePDF && (
          <Menu.Item
            data-testid="consent-form-action-export-pdf"
            // @ts-ignore
            onClick={() => generatePDF(id, consentFormTitle)}
          >
            {t(`general.buttons.exportPDF`)}
          </Menu.Item>
        )}
        {!!edit && (
          <Menu.Item data-testid="consent-form-action-edit" onClick={() => edit(id)}>
            {t(`general.buttons.edit`)}
          </Menu.Item>
        )}
        {!!archive && (
          <Menu.Item data-testid="consent-form-action-archive" onClick={() => archive(id)}>
            {t(`general.buttons.archive`)}
          </Menu.Item>
        )}
        {!!restore && (
          <Menu.Item data-testid="consent-form-action-restore" onClick={() => restore(id)}>
            {t(`general.buttons.restore`)}
          </Menu.Item>
        )}
      </Menu>
    </div>
  )
}

const styles = {
  button: {
    borderRadius: 0,
  },
  menu: {
    borderRadius: 4,
    boxShadow:
      '0 1px 3px hsla(0, 0%, 0%, 0.05), 0 2px 4px hsla(0,0%,0%,0.05), 0 -1px 3px hsla(0, 0%, 0%, 0.05), 0 -2px 4px hsla(0,0%,0%,0.05)',
    minWidth: 120,
  },
  menuItem: {
    margin: 0,
    padding: 0,
  },
}

export default ConsentPopover
